export default {
  FETCH_IMPORT_MAPPING_DATA_SUCCESS: 'FETCH_IMPORT_MAPPING_DATA_SUCCESS',
  RESET_IMPORT_MAPPING_DATA_SUCCESS: 'RESET_IMPORT_MAPPING_DATA_SUCCESS',
  UPDATE_CONTAINER_LIST: 'UPDATE_CONTAINER_LIST',
  SET_MAPPED_FIELD: 'SET_MAPPED_FIELD',
  SET_ACTIVE_DIVISION: 'SET_ACTIVE_DIVISION',
  BACKUP_MAPPED_FIELDS: 'BACKUP_MAPPED_FIELDS',
  LOADED_MAPPED_FIELDS_DIVISION: 'LOADED_MAPPED_FIELDS_DIVISION',
  LOADED_MAPPED_FIELDS: 'LOADED_MAPPED_FIELDS',
  RESTORE_MAPPED_FIELDS: 'RESTORE_MAPPED_FIELDS',
  RESTORE_MAPPED_FIELDS_IN_DIVISION: 'RESTORE_MAPPED_FIELDS_IN_DIVISION',
  RESET_MAPPED_FIELDS_IN_DIVISION: 'RESET_MAPPED_FIELDS_IN_DIVISION',
  ADD_DIVISION_MAP_TO_MAPPING: 'ADD_DIVISION_MAP_TO_MAPPING'
};



// WEBPACK FOOTER //
// ./src/redux/mapping/MappingConstants.js